import { useState } from "react";
import Navbar from "@/components/homepage/Navbar";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import AIUpdates from "@/components/homepage/AIUpdates";
import ResourceHero from "@/components/resources/Hero";
import PromptVault from "@/components/resources/PromptVault";
import FeaturedThisWeek from "@/components/resources/FeaturedThisWeek";
import LiveWorkshops from "@/components/resources/LiveWorkshops";
import { FORM_CONFIGS } from "@/config/forms";
import InviteSection from "@/components/homepage/InviteSection";

const Resourcepage = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <ResourceHero />
      <FeaturedThisWeek />
      <AIUpdates heading="Daily 24hr AI Roundup" />
      <LiveWorkshops />
      <PromptVault />
      <InviteSection />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="resource-hero"
        ctaSectionId="resource-cta"
        marketingBasePath="/resources"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
        formConfig={FORM_CONFIGS.resources}
      />
    </main>
  );
};

export default Resourcepage;
